/* Legends free-shipping progress bar — pure state, no DOM and no network.
   Loaded before legends-cart-drawer.js, which paints the result. */
(function (window) {
  'use strict';

  /* Decide whether the free-shipping bar may be shown, and where the cart sits against
     the threshold.

     `freeShip` comes from snippets/legends-free-ship-map.liquid: either null, or
     { amount, currency } for the CURRENT country, in that country's own presentment
     currency. It is null for every country whose delivery zone has no free-shipping
     rate — 174 of the 218 zoned countries, including all of Rest of World and
     Brazil/Mexico.

     The bar previously fell back to a per-currency threshold when the country was
     unknown, which promised free shipping to 161 countries that cannot deliver it.
     There is deliberately no fallback here: anything we cannot state exactly, we do
     not state at all.

     `amount` is in major units (130 means £130); cart totals are in the currency's
     subunit. Shopify appends hundredths even for currencies without subunits — 1000 JPY
     is 100000 — so the x100 holds for HUF and ISK too. */
  function freeShipState(cart, freeShip, currency) {
    var hidden = { show: false };

    if (!cart || !cart.item_count) return hidden;
    if (!freeShip) return hidden;

    var threshold = freeShip.amount;
    if (typeof threshold !== 'number' || !isFinite(threshold) || threshold <= 0) return hidden;

    /* Stale-map guard. The map is generated per country; if a market's currency changes
       and nobody regenerates, the amount is a number in the wrong currency. Hide rather
       than show "spend 4400 more" to someone paying euros. */
    if (!currency || freeShip.currency !== currency) return hidden;

    var total = cart.total_price;
    if (typeof total !== 'number' || !isFinite(total) || total < 0) return hidden;

    var thresholdSub = threshold * 100;
    var remaining = thresholdSub - total;

    return {
      show: true,
      unlocked: remaining <= 0,
      remaining: remaining > 0 ? remaining : 0,
      pct: Math.max(0, Math.min(100, (total / thresholdSub) * 100))
    };
  }

  window.LegendsShipBar = { freeShipState: freeShipState };
})(typeof window !== 'undefined' ? window : this);
